export default __webpack_public_path__ + "static/media/element_104.acd51e20.jpg";